import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppSettings } from '../const/app.consts';
import { Empresa } from '../model/empresa';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  constructor(
    private http: HttpClient
  ) { }

  buscarDadosEmpresa(tokenMotor: string): Observable<Empresa> {
    const API = `${AppSettings.API_ENDPOINT}/api/snippet/motor/buscarDadosEmpresa?tokenMotor=${tokenMotor}`;
    return this.http.get<Empresa>(API);
  }

}
